<template>
  <select v-model="selectedIcon">
    <option
      value=""
      :selected="icon === ''"
      v-text="'Select an icon'"
    />
    <option
      v-for="(slug, name) in icons"
      :key="slug"
      :value="slug"
      :selected="icon === slug"
      v-html="name"
    />
  </select>
</template>

<script type="text/babel">
export default {
  name: 'ResourceIconSelector',
  model: {
    prop: 'icon',
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      selectedIcon: '',
    }
  },
  computed: {
    icons() {
      return {
        'Thumbs Up': 'thumbs_up',
        'Person': 'person',
        'Screen': 'screen',
        'Chart': 'chart',
        'Doctor': 'doctor',
        'Justice Scale': 'justice_scale',
        'Home': 'home',
        'Link': 'link',
        'Heartbeat': 'heartbeat',
        'Checkmark': 'checkmark',
      }
    },
  },
  watch: {
    icon(newValue) {
      this.selectedIcon = newValue
    },
    selectedIcon(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit('input', this.selectedIcon)
      }
    },
  },
  async mounted() {
    await this.$nextTick()

    this.selectedIcon = this.icon
  },
}
</script>
